import React from "react";
import { Container, Row, Col } from 'react-bootstrap';
import parse from "html-react-parser";
import { Link } from "gatsby";
import { ImageModule } from "../../common/Image_Module";
import { FeaturedNews as getFeaturedNews, FeaturedNewsByCategory } from "../../../queries/common_use_query";
import { AltSiteName, NewsBaseURL } from "../../utils";
import "./FeaturedNews.scss";

const FeaturedNews = ({ categorySlug }) => {

    const { loading, error, data } = categorySlug ? FeaturedNewsByCategory(0, 1, categorySlug) : getFeaturedNews(0,1);
  
    if (!data || !data.newsBlogs || data.newsBlogs.length === 0) return null;

    const featuredNews = data?.newsBlogs[0];

    const removeTags = (str) => {
        // Check if the input string is null or empty
        if (str === null || str === '') {
            return '';
        } else {
            // Convert the input to a string
            str = str.toString();
            return str.replace(/<[^>]*>/g, '');
        }
    };

    return (
        <section className="featured-news">
            <Row className="featured-news-item">
                <Col md={6} lg={7} className="featured-left">
                    <Link to={`${NewsBaseURL}${featuredNews.Select_News_Category ? '/' + featuredNews.Select_News_Category?.URL : ''}/${featuredNews.URL}/`} className="img-link">
                        <ImageModule ImageSrc={featuredNews.Tile_Image} ggfx_results={featuredNews.ggfx_results} altText={featuredNews.Tile_Image.alternativeText ? featuredNews.Tile_Image.alternativeText : featuredNews.Title} strapi_id={featuredNews.id} imagename={"news-blogs.Tile_Image.featuredtile"} />
                    </Link>
                </Col>
                <Col md={6} lg={5} className="featured-right">
                    <h2><Link to={`${NewsBaseURL}${featuredNews.Select_News_Category ? '/' + featuredNews.Select_News_Category?.URL : ''}/${featuredNews.URL}/`} className="blog-link">{featuredNews.Title}</Link></h2>
                    <div className="content">{parse(removeTags(featuredNews.Short_Intro.substr(0, 190) + '...'))}</div>
                    <div className="view-link"><Link to={`${NewsBaseURL}${featuredNews.Select_News_Category ? '/' + featuredNews.Select_News_Category?.URL : ''}/${featuredNews.URL}/`} className="blog-link">View Article</Link></div>
                </Col>
            </Row>
        </section>
    );
};

export default FeaturedNews;